import React from 'react'
import classNames from 'classnames'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import { toTitleCase } from 'src/utils/helpers/StringHelper'
import programStyles from '../programStyles.module.scss'

const ImageWithText = ({ clickEvent, imageUrl, linkText, overlayText }) => (
  <button
    onClick={clickEvent}
    className={classNames(programStyles.imageWithTextButton)}
  >
    <div
      className={programStyles.backgroundImage}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className={programStyles.textContainer}>
        <span className={fontStyles.h4lsinneutral01whitegartnersans23pt} data-testid='overlayText'>{overlayText}</span>
        <div className={generalStyles.mt55}>
          <span className={fontStyles.psmallboldlsinneutral01whitegartnersans15pt} data-testid='linkText'>
            {toTitleCase(linkText)}
          </span>
        </div>
      </div>
    </div>
  </button>
)

export default ImageWithText
